import { GetServerSideProps } from 'next';
import { getPageData } from 'api';
import { checkIfFullyAuthorized, getRedirectUrlWithQuery } from 'utils/services';
import { getCommonOgData, getPageDescription } from 'utils/seoFormatters';
import { getCanonicalUrlFromContext } from 'utils/formatters';
import { SignIn, SignInPlaceholder } from 'containers/SignInPage';
import { SignInPageProps } from 'types';
import { isEmpty } from 'utils/toggleParams';

const SignInPage = (props: SignInPageProps) => {
  const { query, user } = props;
  const shopifySid = query?.shopify_sid;

  if (user && !isEmpty(user) && checkIfFullyAuthorized(user) && shopifySid) {
    return <SignInPlaceholder shopifySid={shopifySid as string} />;
  }

  return <SignIn {...props} shopifySid={shopifySid as string} />;
};

export const getServerSideProps: GetServerSideProps = async (context) => {
  const onboarding = await getPageData('onboarding', !!context.query.force);

  const redirectUrl = getRedirectUrlWithQuery(context.query);

  return {
    props: {
      signInSlides: onboarding?.content?.sections || [],
      redirectUrl,
      ogData: getCommonOgData({
        url: getCanonicalUrlFromContext(context),
        title: 'Sign In | SENDY',
        description: getPageDescription('signIn'),
      }),
    },
  };
};

export default SignInPage;
